import React from 'react';
import { NavLink } from 'react-router-dom';
import { House, SquaresFour, Bell, User } from '@phosphor-icons/react';

/**
 * Solid green bottom nav for authenticated mobile experience.
 * Matches the new Divispend chunky-app aesthetic.
 * Marketplace tab removed for the B2B pivot — restore when marketplace scales back in.
 */
const TABS = [
  { to: '/dashboard',  icon: House,       label: 'Home' },
  { to: '/feed',       icon: SquaresFour, label: 'Apps' },
  { to: '/messages',   icon: Bell,        label: 'Alerts' },
  { to: '/profile',    icon: User,        label: 'Profile' },
];

export default function MobileBottomNav() {
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 bg-[#22C55E] px-2 pt-2 pb-[max(0.6rem,env(safe-area-inset-bottom))] md:hidden shadow-[0_-8px_24px_rgba(0,0,0,0.4)]"
      data-testid="mobile-bottom-nav"
    >
      <ul className="flex items-center justify-around">
        {TABS.map(({ to, icon: Icon, label }) => (
          <li key={to}>
            <NavLink
              to={to}
              data-testid={`bn-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center px-3 py-1.5 rounded-md transition-all ${
                  isActive ? 'bg-black/15' : 'hover:bg-black/10'
                }`
              }
              aria-label={label}
            >
              {({ isActive }) => (
                <>
                  <Icon className="w-7 h-7 text-white" weight={isActive ? 'fill' : 'regular'} />
                  {isActive && <span className="w-1 h-1 rounded-full bg-white mt-0.5" />}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
